import React, { useEffect, useState } from "react";
import { message, Modal, Select } from "antd";
import { platformApi } from "../../../../../api";

const { Option } = Select;

const AssignMechanic = ({ open, close, selectedRamp, assignedMechanics = [] }) => {
  const [mechanics, setMechanics] = useState([]);
  const [selectedMechanic, setSelectedMechanic] = useState();

  useEffect(() => {
    if (open) {
      getMechanics();
    }
  }, [open]);

  useEffect(() => {
    if (selectedRamp?.mechanic) {
      setSelectedMechanic(selectedRamp?.mechanic?.id);
    }
  }, [selectedRamp]);

  const getMechanics = () => {
    platformApi
      .get("/api/user")
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let list = data.data.users.filter((item) => {
            return (
              item.profile &&
              item.profile.department.role === "Mechanic" &&
              item.status === true &&
              Array.isArray(item.profile.branch) &&
              item.profile.branch.some(
                (branch) => branch.id === selectedRamp.branch.id
              ) &&
              // 🚫 Exclude already assigned mechanics
              (!assignedMechanics.includes(item.id) || item.id === selectedRamp?.mechanic?.id)
            );
          });
          setMechanics(list);
        }
      })
      .catch((err) => {
        console.error("Error getting mechanic", err);
      });
  };

  const assignMechanic = () => {
    if (!selectedMechanic) {
      message.warning("Please select a mechanic before assigning");
      return;
    }
    const payload = {
      rampId: selectedRamp.id,
      mechanicId: selectedMechanic,
    };
    platformApi
      .post(`/api/ramp/assignMechanic`, payload)
      .then((res) => {
        message.success("Mechanic allocated successfully");
        close();
      })
      .catch((err) => {
        message.error("Error in allocating Mechanic");
        console.error("Error occurred:", err);
      });
  };

  return (
    <Modal
      width="40%"
      title={`Assign Mechanic for Ramp ${selectedRamp?.rampNo}`}
      visible={open}
      onCancel={close}
      onOk={assignMechanic}
      okText={"Assign Mechanic"}
    >
      <div style={{ marginTop: "16px" }}>
        <Select
          placeholder="Select Mechanic"
          style={{ width: "100%" }}
          value={selectedMechanic}
          onChange={(value) => setSelectedMechanic(value)}
        >
          {mechanics?.map((mechanic) => (
            <Option key={mechanic.id} value={mechanic.id}>
              {mechanic.profile?.employeeName}
            </Option>
          ))}
          {selectedMechanic && !mechanics?.some((m) => m.id === selectedMechanic) && (
            <Option key={selectedMechanic} value={selectedMechanic}>
              {selectedRamp?.mechanic?.profile?.employeeName || selectedMechanic}
            </Option>
          )}
        </Select>
      </div>
    </Modal>
  );
};

export default AssignMechanic;
